import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home.vue";
import auth from "@/auth";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/Login.vue"),
    meta: {
      userRoute: true,
    },
  },
  {
    path: "/reset-password",
    name: "send-reset-password",
    meta: {
      userRoute: true,
    },
    component: () => import("@/views/SendResetPassword.vue"),
  },
  {
    path: "/reset-password/:token",
    name: "reset-password",
    meta: {
      userRoute: true,
    },
    props: true,
    component: () => import("@/views/ResetPassword.vue"),
  },
  {
    path: "/logout",
    name: "logout",
  },
  {
    path: "/:homeSlug/weekly-updates",
    name: "weekly-updates",
    component: () => import("@/views/WeeklyUpdates.vue"),
    props: true,
  },
  {
    path: "/our-pledge",
    name: "our-pledge",
    component: () => import("@/views/Basic.vue"),
    props: true,
  },
  {
    path: "/:homeSlug/useful-resources",
    name: "useful-resources",
    component: () => import("@/views/UsefulResources.vue"),
    props: true,
  },
  {
    path: "/:homeSlug/useful-resources/:slug",
    name: "useful-resource",
    component: () => import("@/views/UsefulResource.vue"),
    props: true,
  },
  {
    path: "/:homeSlug/standards",
    name: "standards",
    component: () => import("@/views/Standards.vue"),
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/:homeSlug/news/:slug",
    name: "news-item",
    component: () => import("@/views/NewsItem.vue"),
    props: true,
  },
  {
    path: "/:homeSlug/vff-framework-description",
    name: "vff-framework-description",
    component: () => import("@/views/Basic.vue"),
    props: true,
  },
  {
    path: "/:homeSlug/process-flowchart",
    name: "process-flowchart",
    component: () => import("@/views/Basic.vue"),
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/:homeSlug/contact-us",
    name: "contact-us",
    component: () => import("@/views/Basic.vue"),
    props: true,
  },
  {
    path: "/:homeSlug/terms-and-conditions",
    name: "terms-and-conditions",
    component: () => import("@/views/Basic.vue"),
    props: true,
  },
  {
    path: "/:homeSlug/cookie-policy",
    name: "cookie-policy",
    component: () => import("@/views/Basic.vue"),
    props: true,
  },
  {
    path: "/:homeSlug/privacy-policy",
    name: "privacy-policy",
    component: () => import("@/views/Basic.vue"),
    props: true,
  },
  {
    path: "/:homeSlug/resources",
    name: "resources",
    component: () => import("@/views/Basic.vue"),
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/:homeSlug/:slug",
    name: "basic",
    component: () => import("@/views/Basic.vue"),
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/:homeSlug",
    name: "home",
    component: Home,
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/",
    name: "home-logged-out",
    component: () => import("@/views/Basic.vue"),
    props: true,
  },
  {
    path: "*",
    meta: {
      requiresAuth: true,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!auth.loggedIn()) {
      next({ name: "login", query: { redirect: to.fullPath } });
    } else if (!auth.isUserAllowedInHome(to.params.homeSlug)) {
      next({ name: "logout" });
    } else {
      next();
    }
  }

  if (to.name == "logout") {
    auth.logout();
    window.location.href = '/';
  }

  next();
});

export default router;
